import { render, staticRenderFns } from "./WlogList.vue?vue&type=template&id=12b8b36e"
import script from "./WlogList.vue?vue&type=script&lang=js"
export * from "./WlogList.vue?vue&type=script&lang=js"
import style0 from "./WlogList.vue?vue&type=style&index=0&id=12b8b36e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports